import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeHtmlPipe, SanitizerValueType } from '@pipes/safe-html/safe-html.pipe';

@Component({
  selector: 'app-verified-by-norse-variant-c',
  standalone: true,
  imports: [
    CommonModule,
    SafeHtmlPipe,
  ],
  templateUrl: './verified-by-norse-variant-c.component.html',
  styleUrl: './verified-by-norse-variant-c.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifiedByNorseVariantCComponent {
  @Input() title: string;
  @Output() infoClick = new EventEmitter<void>();

  readonly SanitizerValueType = SanitizerValueType;

  onInfoClick(): void {
    this.infoClick.emit();
  }
}
